import React from 'react'
import { connect } from 'react-redux'

import { Entity } from '../../app/entity'
import Navigator from '../../app/navigator'

import { TraceList } from '../../domain/TraceSummary'
import ProfileList from '../../profile-list'
import { ApplicationState } from '../../redux/ApplicationState'

interface StateProps {
    navigator: Navigator
    parameters: { [name: string]: string }
}

type Props = StateProps & Entity<TraceList>

class Profiles extends React.Component<Props> {
    public render() {
        return (
            <ProfileList
                params={this.props.parameters}
                profileRoute="XhprofProfilerBundle.Profile.quick"
                listRoute="XhprofProfilerBundle.Transaction.show"
                fixedCriteria={{ opId: true, date: true }}
                actions={['view', 'sort', 'clear']}
                showTabs={false}
            />
        )
    }
}

export default connect<Props, {}>((globalState: ApplicationState, props) => {
    const profiles = globalState.operations.profiles[globalState.tidewaysContext.route.parameters.operation] || new Entity()

    return {
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...profiles,
    }
})(Profiles)
